import styled from 'styled-components';

const ImageWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 229px;
  width: 172px;
`;

const RelatedProductsWrapper = styled.div`
  margin: 5% 0% 15% 0%;
`;

const SliderArrow = styled.span`
  font-size: 40px;
  font-weight: 100;
  color: #aaa;
  cursor: pointer;
  &:hover {
    color: #000;
  }
`;

const Title = styled.span`
  color: #000;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-size: 15px;
  letter-spacing: 1px;
  margin: 0 1em;
  text-transform: uppercase;
`;

const ViewMore = styled.div`
  font-size: 15px;
  margin: 48% 10px 0;
  text-align: center;
  
    
  & span {
    font-family: "Avenir Black", "Arial Black", sans-serif;
    font-size: 15px;
  }
`;

export { ImageWrapper, RelatedProductsWrapper, SliderArrow, Title, ViewMore };
